import React, { useContext, useEffect, useState } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import PropTypes from "prop-types";
import MDModal from "components/MDModal";
import { ModalContext } from "context/ModalContext";
import { getBusinessListApi } from "Apis/businessApi";
import BusinessForm from "./Form";
import { getBusinessDataByIdApi } from "Apis/businessApi";
import { BusinessContext } from "context/BusinessContext";
import { deleteBusinessDataApi, verifyBusinessDataApi } from "Apis/businessApi";
import Swal from "sweetalert2";
import { LoginFormContext } from "context/LoginFormContext";
import { MODULES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import { MemberContext } from "context/MemberContext";
import business from "../../../assets/images/placeholder.jpg";
import VerifiedIcon from "@mui/icons-material/Verified";
import MDActionButton from "components/MDActionButton";
import colors from "assets/theme/base/colors";
import VerifiedStatus from "components/MDVerifiedStatus";
import Imagepreview from "components/MDImagePreview";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import moment from "moment";

function BusinessTable() {
  const { setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const { setEditData, categoriesList, getCategoryApi, getSubCategoryApi } =
    useContext(BusinessContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    access,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
  } = useContext(LoginFormContext);
  const { parentDataListing } = useContext(MemberContext);
  const { imageBorder } = colors;
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const [filterVal, setFilterVal] = useState({
    name: "",
    category: "",
    owner_name: "",
    phone_number: "",
    email: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  const obj = {
    ...defaultFilter,
    filters: {
      name: filterVal.name,
      category: filterVal.category,
      owner_name: filterVal.owner_name,
      phone_number: filterVal.phone_number,
      email: filterVal.email,
      is_active: filterVal?.is_active?.value,
      is_verified: filterVal?.is_verified?.value,
    },
  };

  useEffect(() => {
    getModuleAccess(MODULES.BUSINESS);
  }, [modules]);

  useEffect(() => {
    parentDataListing();
    getCategoryApi();
    getSubCategoryApi();
  }, []);

  // get businessdata api //
  const [businessdata, setBusinessData] = useState([]);
  const getbusinessAllData = async () => {
    let response = await getBusinessListApi(obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setBusinessData(response.data.data.rows);
      setRowCount(response?.data?.data?.count);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getbusinessAllData();
  }, [filterVal, defaultFilter]);

  // edit businessdata api //
  const handleEdit = async (row) => {
    let response = await getBusinessDataByIdApi(row.id);
    if (response?.status === 200) {
      setFilterLoader(false);
      setOpen(true);
      setFormIsEdit(true);
      setEditData(response?.data?.data);
    }
  };

  // delete businessdata api //
  const handleDelete = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want really to delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      let response = await deleteBusinessDataApi(row.id);
      if (response?.status === 200) {
        setFilterLoader(false);
        businessdata?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
        getbusinessAllData();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "check",
          title: "error",
          content: response.data.message,
          open: true,
        });
      }
    }
  };

  // verify businessdata api //
  const handleVerify = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want really to verify this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, verify it!",
    });
    if (result.isConfirmed) {
      let response = await verifyBusinessDataApi(row.id);
      if (response?.status === 200) {
        setFilterLoader(false);
        businessdata?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
        getbusinessAllData();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "check",
          title: "error",
          content: response.data.message,
          open: true,
        });
      }
    }
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "name",
        accessor: "name",
        sort: true,
        filterLabel: "Name",
        filterAccessor: "name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value, row }) => {
          const imageUrl = row?.original?.business_images[0]?.image;

          const [imgError, setImgError] = React.useState(false);
          const isVerified = row?.original?.is_verified === 1;

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {imageUrl && !imgError ? (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <img
                    src={imageUrl}
                    alt="image"
                    onError={() => setImgError(true)}
                    onClick={() => handleImageClick(imageUrl)}
                    style={{
                      height: "50px",
                      width: "50px",
                      borderRadius: "100%",
                      objectFit: "cover",
                      border: `1px solid ${imageBorder.borderColor}`,
                      cursor: "pointer",
                    }}
                  />
                  {isVerified && (
                    <VerifiedIcon
                      sx={{
                        position: "absolute",
                        bottom: "5px",
                        right: 0,
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        width: "16px",
                        height: "16px",
                        color: `${imageBorder.verifiedIconColor}`,
                      }}
                    />
                  )}
                </div>
              ) : (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <img
                    src={business}
                    alt="image"
                    style={{
                      height: "50px",
                      width: "50px",
                      borderRadius: "100%",
                      objectFit: "fill",
                      border: `1px solid ${imageBorder.borderColor}`,
                    }}
                  />
                  {isVerified && (
                    <VerifiedIcon
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        width: "16px",
                        height: "16px",
                        color: `${imageBorder.verifiedIconColor}`,
                      }}
                    />
                  )}
                </div>
              )}
              <DefaultCell value={value || "-"} />
            </div>
          );
        },
      },
      {
        Header: "category",
        accessor: "category_id",
        filterLabel: "Category",
        filterAccessor: "category",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => {
          const category = categoriesList.find((item) => item.id === value);
          return <DefaultCell value={category ? category.label : "-"} />;
        },
      },
      {
        Header: "owner name",
        accessor: "owner_name",
        sort: true,
        filterLabel: "Owner name",
        filterAccessor: "owner_name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "phone number",
        accessor: "phone_number",
        sort: true,
        filterLabel: "Phone Number",
        filterAccessor: "phone_number",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "email",
        accessor: "email",
        sort: true,
        filterLabel: "Email",
        filterAccessor: "email",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "Verification Status",
        accessor: "is_verified",
        minWidth: "115px",
        sort: true,
        filterLabel: "Verification Status",
        filterAccessor: "is_verified",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Verified", value: "1" },
          { label: "Not Verified", value: "0" },
        ],
        Cell: ({ value }) => <VerifiedStatus data={value} />,
      },
      {
        Header: "Created date",
        accessor: "createdAt",
        sort: true,
        Cell: ({ value }) => (
          <DefaultCell value={value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} />
        ),
      },
      {
        Header: "Status",
        accessor: "is_active",
        minWidth: "115px",
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="business"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEdit(row.original)} />
            )}
            {access?.delete_access && (
              <MDActionButton type="delete" onClick={() => handleDelete(row.original)} />
            )}
            {access?.write_access && row.original.is_verified === 0 && (
              <MDActionButton type="verify" onClick={() => handleVerify(row.original)} />
            )}
          </MDBox>
        ),
      },
    ],
    rows: businessdata,
  };

  return (
    !isLoading && (
      <DashboardLayout>
        <DashboardNavbar />
        <>
          <MDModal
            hasButton={access?.write_access ?? false}
            btnText="Add Business"
            modalHead={`${formIsEdit ? "Edit" : "Add"} Business`}
          >
            <BusinessForm getbusinessAllData={getbusinessAllData} />
          </MDModal>
          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            canSearch={true}
            rowCount={rowCount}
            getDataList={getbusinessAllData}
            tableTitle="Business List"
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
          {selectedImage && (
            <Imagepreview
              open={isImageModalOpen}
              onClose={() => setIsImageModalOpen(false)}
              imageUrl={selectedImage}
            />
          )}
        </>
      </DashboardLayout>
    )
  );
}
BusinessTable.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default BusinessTable;
